import SectionHeading from '@/components/feature/SectionHeading';
import DramaCard from '@/components/feature/DramaCard';
import { dramas } from '@/mocks/dramas';
import type { Drama } from '@/types/content';

const hotList = ([...dramas] as Drama[])
  .sort((a, b) => b.heat - a.heat)
  .slice(0, 6);

export default function HotDramas() {
  return (
    <section id="hot" className="w-full scroll-mt-24 border-b border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-content px-4 md:px-6">
        <SectionHeading
          eyebrow="Hot Picks"
          title="热门短剧推荐"
          desc="按近期追剧热度排序的在追短剧，每部都已整理好连续剧集更新顺序与分集剧情介绍。"
          actionText="浏览全部剧集"
          actionTo="/dramas"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {hotList.map((drama, index) => (
            <DramaCard key={drama.id} drama={drama} rank={index + 1} />
          ))}
        </div>
      </div>
    </section>
  );
}